import type { CompareOp, EventTypeStrEnum, FilterComparatorDataType, MatchingMethodStrEnum } from "./types";

export const decisioningStudioAgentsAppGroupIdDsaIdConversionEvents =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/conversion_events";

export const matchingMethods: MatchingMethodStrEnum[] = [
  "action_ids",
  "action_parameters",
  "event_parameters",
  "proximity",
  "rec_id",
];

export const eventTypes: EventTypeStrEnum[] = [
  "Cadence recommended",
  "Conversion",
  "Daysofweek recommended",
  "Email clicked",
  "Email opened",
  "Email sent",
  "Email unsubscribed",
  "Frequency recommended",
  "Inbound call connected",
  "Inbound call dialed",
  "In app notification clicked",
  "In app notification opened",
  "In app notification sent",
  "In app notification unsubscribed",
  "Multi channel interacted",
  "Multi channel sent",
  "Multi channel unsubscribed",
  "Outbound call connected",
  "Outbound call dialed",
  "Outbound call unsubscribed",
  "Popup clicked",
  "Popup disabled",
  "Popup displayed",
  "Push notification clicked",
  "Push notification opened",
  "Push notification sent",
  "Push notification unsubscribed",
  "Recommendation sent",
  "Recommended",
  "SMS clicked",
  "SMS opened",
  "SMS sent",
  "SMS unsubscribed",
];

export const compareOps: CompareOp[] = [
  "contains",
  "contains_item",
  "endswith",
  "eq",
  "geq",
  "gt",
  "isin",
  "isnull",
  "is_subset",
  "largest_n",
  "last_N_digits",
  "leq",
  "like",
  "lt",
  "neq",
  "notcontains",
  "notin",
  "notnull",
  "smallest_n",
  "startswith",
];

export const filterDataTypes: FilterComparatorDataType[] = [
  "bool",
  "datetime",
  "float",
  "integer",
  "number",
  "string",
];
